/**
 * Created by camiel on 05/04/2017.
 */

import Stage = createjs.Stage;

import Utils from "./utils";

export default class StageCanvas {
  public readonly canvas: HTMLCanvasElement;
  public readonly stage: Stage;

  private _mounted: boolean = false;
  private _autoUpdating: boolean = false;

  constructor(
    private readonly _width: number,
    private readonly _height: number,
  ) {
    this.canvas = document.createElement("canvas");
    this._initializeCanvas();

    this.stage = new createjs.Stage(this.canvas);

    if (createjs.Touch.isSupported()) {
      createjs.Touch.enable(this.stage, true);
    }

    this._initializeStage();
  }

  public startAutoUpdating(): void {
    if (this._autoUpdating) {
      return;
    }

    this.stage.update();
    createjs.Ticker.addEventListener("tick", this._onTick);
    this._autoUpdating = true;
  }

  public stopAutoUpdating(): void {
    if (!this._autoUpdating) {
      return;
    }

    createjs.Ticker.removeEventListener("tick", this._onTick);
    this._autoUpdating = false;
  }

  public mount(autoUpdate: boolean = false): void {
    if (autoUpdate) {
      this.startAutoUpdating();
    }

    if (this._mounted) {
      return;
    }

    document.body.appendChild(this.canvas);
    this._mounted = true;
  }

  public unmount(): void {
    this.stopAutoUpdating();

    if (!this._mounted) {
      return;
    }

    document.body.removeChild(this.canvas);
  }

  public get width(): number {
    return this._width;
  }

  public get height(): number {
    return this._height;
  }

  private _initializeCanvas(): void {
    this.canvas.className = "stage-canvas";

    this.canvas.width = this._width;
    this.canvas.height = this._height;

    Utils.init(this.canvas);
  }

  private _initializeStage(): void {
    if (this.canvas.width !== Utils.WIDTH) {
      // this.stage.scaleX = this.stage.scaleY = this.canvas.width / Utils.WIDTH;
    }

    if (createjs.Touch.isSupported()) {
      createjs.Touch.enable(this.stage, true);
    }
  }

  private _onTick = () => {
    this.stage.update();
  }
}



// WEBPACK FOOTER //
// ../lib/src/StageCanvas.ts